document.addEventListener("DOMContentLoaded", function () {
  const counterDiv = document.querySelector(".st-counter");
  if (!counterDiv) {
    console.warn("⚠️ .st-counter not found");
    return;
  }
  const viewCountEl = counterDiv.querySelector(".view-count");

  function updateViewCount() {
    const products = document.querySelectorAll("#collectionmodalcontainer #ProductsList .card .product-card"); // ✅ dynamic
    if (products.length === 0) return;

    let viewedCount = 0;
    const scrollBottom = window.scrollY + window.innerHeight;

    products.forEach((product, i) => {
      const rect = product.getBoundingClientRect();
      const absoluteTop = rect.top + window.scrollY;

      if (absoluteTop < scrollBottom) {
        viewedCount = i + 1;
      }
    });

    viewCountEl.textContent = viewedCount;

    // Show counter after 6 products
    counterDiv.style.display = viewedCount > 12 ? "flex" : "none";
  }

  updateViewCount();
  window.addEventListener("scroll", updateViewCount);
  window.addEventListener("resize", updateViewCount);

  // Hide counter when footer is visible
  const footer = document.querySelector("footer.footer");
  if (footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            counterDiv.style.display = "none";
          } else {
            updateViewCount();
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(footer);
  }

  // ✅ Update counter after new products are added via infinite scroll
//   window.addEventListener("st.collection.paginated", updateViewCount);
});

document.addEventListener("DOMContentLoaded", () => {
  let backToTop = document.querySelector(".st-collection-scroll-top");

  if (backToTop) {
    // scroll-to-top on click
    backToTop.addEventListener("click", () => {
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }

  window.addEventListener("scroll", () => {
    if (backToTop && window.scrollY > 500) {
      backToTop.style.display = "flex";
    } else if (backToTop && window.scrollY <= 500) {
      backToTop.style.display = "none";
    }
  });
});